module.exports = __webpack_public_path__ + "img/freewave1_01.bb4f5762.jpg";